/**
 * @ngdoc module
 * @name LoginForm
 * @description LoginForm component for resetting password and logging in.
 * @constructor
 */
import routerConfig from './loginForm.route.js';
import loginFormDirective from './loginForm.directive.js';

angular.module('app.loginForm', ['ngAnimate', 'app.services', 'ui.router'])
  .config(routerConfig)
  .directive('loginForm', loginFormDirective);



/** WEBPACK FOOTER **
 ** ./src/app/components/loginForm/loginForm.module.js
 **/